import { render } from "./StoresPopup.vue?vue&type=template&id=510e9b48&scoped=true"
import script from "./StoresPopup.vue?vue&type=script&lang=js"
export * from "./StoresPopup.vue?vue&type=script&lang=js"

import "./StoresPopup.vue?vue&type=style&index=0&id=510e9b48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510e9b48"]])

export default __exports__